var _a;
/**
 * A utility to hide the default canvas style focus ring when using mouse input.
 * Requires wrapping your components in an InputProvider component.
 */
export var hideMouseFocus = (_a = {},
    _a["[data-whatinput=\"mouse\"] &:focus,\n    [data-whatinput=\"touch\"] &:focus,\n    [data-whatinput=\"pointer\"] &:focus"] = {
        outline: 'none',
        boxShadow: 'none',
        animation: 'none',
    },
    _a);
/*
 * A utility that simplifies focus selectors since you can't use nested syntax for some reason. Example:
 * [`[data-whatinput="mouse"],
     [data-whatinput="touch"],
     [data-whatinput="pointer"]: {
       '& .my-selector': {
          ...
       }
   },
 */
export var mouseFocusBehavior = function (selectors) {
    var output = {};
    Object.keys(selectors).map(function (selector, index) {
        selector.split(',').forEach(function (selectorPart) {
            var prefixedSelector = "\n        [data-whatinput=\"mouse\"] " + selectorPart + ",\n        [data-whatinput=\"touch\"] " + selectorPart + ",\n        [data-whatinput=\"pointer\"] " + selectorPart;
            output[prefixedSelector] = selectors[selector];
        });
    });
    return output;
};
